var map = {
	"./review-1.png": "120c",
	"./review-2.png": "6999",
	"./review-3.png": "421f",
	"./review-4.png": "4fd5",
	"./review-5.png": "9b4a",
	"./review-6.png": "2f79",
	"./review-7.png": "9a6d",
	"./review-8.png": "347b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dad";